<script lang="ts" setup>
  import { computed } from "vue";
  import { useAppStore } from "@/stores/app";
  import { useDisplay } from "vuetify";

  const props = withDefaults(defineProps<{
    height?: number;
    compact?: boolean;
    minimal?: boolean;
  }>(), {
    height: undefined,
    compact: false,
    minimal: false,
  });

  const { mobile } = useDisplay();

  const appStore = useAppStore();
  const maxContentHeight = computed(() => `${appStore.windowHeight - 48}px` );
  const maxContentHeightScroll = computed(() => `${appStore.windowHeight - 48 - (mobile ? 112 : (props.compact ? 60 : 90))}px` );
</script>

<template>
  <div
    :class="{
      'simple-bg': true,
      'compact': compact,
    }"
  >
    <div
      :class="{
        'content': true,
        'no-padding': props.minimal
      }"
      :style="{ maxHeight: maxContentHeight, height: props.height ? `${props.height}px` : 'auto' }"
    >
      <div
        class="scroll"
        :style="{ maxHeight: maxContentHeightScroll }"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .simple-bg {
    border-radius: 1.5rem;

    display: flex;
    flex-direction: column;
  }

  .content {
    background-color: rgb(var(--v-theme-background));
    color: rgb(var(--v-theme-neutral-600));
    padding: 5rem;
    border-radius: 24px;

    .scroll {
      overflow-x: hidden;
      overflow-y: auto;

      -ms-overflow-style: none;  /* IE and Edge */
      scrollbar-width: none;  /* Firefox */
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .compact {
    .content {
      padding: 2rem;
    }
  }

  .no-padding{
    border-radius: 2rem;
    padding: 0;
  }

  @media(max-width: breakpoint(md) - 1px) {
    .simple-bg {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;

      .content {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;

        padding: 6rem 2rem 2rem 2rem;
      }
      .no-padding{
        border-radius: 2rem;
        padding: 0;
      }
    }
  }
</style>
